module.exports = __webpack_public_path__ + "static/media/movie-banner.7c546004.jpg";